/**
 * RBAC：`GET /admin/v1/me/permissions` 返回值与路由元数据对齐。
 * 超级管理员 `"*"` 直通；其余为细粒度字符串（首期与 admin-api `permissionsForRole` 对齐）。
 */
export function hasPermission(
  perms: string[],
  required: readonly string[]
): boolean {
  if (perms.includes("*")) return true;
  if (!required.length) return true;
  return required.some((p) => perms.includes(p));
}
